import styled from "styled-components";

import { colorsPalettes, rgba } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { desktopMedia } from "app/pages/sales-intelligence/modules/manage-integrations/containers/styles";
import ManagementPageWrapper from "app/pages/sales-intelligence/pages/management/components/ManagementPageWrapper/ManagementPageWrapper";
import { StyledManagementPageWrapper } from "app/pages/sales-intelligence/pages/management/components/ManagementPageWrapper/styles";
import { AssetsService } from "app/services/AssetsService";

export const StyledGatewayPageWrapper = styled(ManagementPageWrapper)<{ $hasFixedFooter?: boolean }>`
    background: url(${AssetsService.assetUrl("/images/light-background.png")});
    background-size: 100%;
    background-repeat: no-repeat;

    ${StyledManagementPageWrapper} {
        padding: 80px 0 ${({ $hasFixedFooter }) => ($hasFixedFooter ? "120px" : "80px")};
        max-width: 791px;

        ${desktopMedia`
            max-width: 1084px;
        `}
    }
`;

export const StyledGatewayActionsRow = styled(Flex)`
    justify-content: center;
    align-items: center;
    gap: 20px;
    width: 100%;
`;

export const StyledGatewayLearnMoreButton = styled(IconButton)`
    justify-content: center;

    & > div {
        flex-grow: unset;
    }
`;

export const StyledGatewayPrimaryButton = styled(IconButton)`
    width: auto;
    height: 40px;
    border-radius: 999px;
    padding: 0 20px;

    & > div {
        flex-grow: unset;
    }
`;

export const StyledHowDoesItWorkLine = styled.div`
    border-top: 1px solid ${colorsPalettes.carbon["100"]};
    flex: 1 0 auto;
    height: 0;
`;

export const StyledGatewayPageList = styled.ul`
    list-style-type: disc;
    margin: 0 0 0 20px;

    & > li:not(:last-of-type) {
        margin-bottom: 16px;
    }
`;

export const StyledConnectGAIllustrationWrapper = styled(Flex)`
    flex: 1 0 auto;
    justify-content: center;
    align-items: center;
    height: 246px;
    overflow: hidden;
`;

export const StyledDCWalletIllustrationWrapper = styled(Flex)`
    flex: 1 0 auto;
    justify-content: center;
    align-items: center;
    width: 306px;
    overflow: hidden;
`;

export const StyledFixedGatewayActions = styled(Flex)`
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
    justify-content: center;
    align-items: center;
    gap: 20px;
    padding: 16px 24px;
    background: ${rgba(colorsPalettes.carbon["0"], 0.92)};
    backdrop-filter: blur(8px);
    border-top: 1px solid ${colorsPalettes.carbon["100"]};
    box-shadow: 0 -4px 12px rgba(14, 30, 62, 0.08);
`;
